import React, { useState } from "react";
import { Modal, Text, Stack, Paper, Group, Box, Badge, Flex, Center, Card, ActionIcon, Loader } from "@mantine/core";
import ActionIconFile from '../ActionIconFile'
import { IconDownload, IconFile } from "@tabler/icons-react";
import { base64ToBlob, fetchFile, openFileInNewTab } from "../../utils/fileService";
import { useSelector } from "react-redux";

const ModalUnitEvidences = ({ opened, onClose, evidences }) => {

  const { user } = useSelector((state) => state.auth);
  const [downloadingFiles, setDownloadingFiles] = useState(new Set());

  const handleDownloadEvidence = async (fileId, fileName, fileType) => {
    setDownloadingFiles(prev => new Set(prev).add(fileId));
    try {
      const fileData = await fetchFile(fileId, user.token);
      if (!fileData) return;
      const fileBlob = base64ToBlob(fileData, fileType);

      openFileInNewTab(fileBlob);
      
    } catch (error) {
      console.error('Error al descargar el archivo:', error);
    } finally {
      setDownloadingFiles(prev => {
        const newSet = new Set(prev);
        newSet.delete(fileId);
        return newSet;
      });
    }
  };

  return (
    <Modal
      opened={opened}
      onClose={onClose}
      title={<Text fw={700} size="xl">Evidencias Cargadas</Text>}
      size="lg"
      radius="md"
      overlayProps={{
        backgroundOpacity: 0.55,
        blur: 2,
      }}
    >
      <Stack spacing="md">
        {evidences?.length > 0 ? (
          evidences.map((evidence, index) => {
            const mainFile = evidence.archivos?.find((a) => a.esPrincipal)
            return(
              <Paper
                key={index}
                shadow="xs"
                radius="md"
                p="md"
                withBorder
                style={{ backgroundColor: "#f8f9fa" }}
              >
                <Stack gap={'sm'}>
                  <Flex gap="lg" justify="flex-start" align="center" direction="row" wrap="nowrap">
                    <ActionIcon 
                      radius={'md'} 
                      color="#e72166" 
                      title="Descargar" 
                      onClick={() => handleDownloadEvidence(mainFile.Id, mainFile.nombre, mainFile.tipoArchivo)}
                      loading={downloadingFiles.has(mainFile.Id)}
                      disabled={downloadingFiles.has(mainFile.Id)}
                    >
                      {downloadingFiles.has(mainFile.Id) ? (
                        <Loader size="xs" color="white" />
                      ) : (
                        <IconFile height={'70%'} width={'70%'}/>
                      )}
                    </ActionIcon>
                    <Text size="md" fw={600} tt="uppercase">{evidence.titulo}</Text>
                  </Flex>
                  <Box>
                    <Text c={'dimmed'}>{evidence?.descripcion}</Text>
                  </Box>
                  <Box>
                    <Group>
                      <Badge size="lg" variant="default">{evidence.unidadesGestion[0]?.codigoUnidadGestion} - {evidence.unidadesGestion[0]?.codigoSede}</Badge>
                      {evidence.kpis?.map((kpi) => (
                        <Badge key={kpi.Id} variant="default" size="lg">
                          <Text inherit><Text span inherit c={'#e72166'}>KPI {kpi.numKpi}.</Text> {kpi.titulo} </Text>
                        </Badge>
                      ))}
                    </Group>
                  </Box>
                </Stack>
              </Paper>
            ) 
          })
        ) : (
          <Text c="dimmed" ta="center">
            No hay evidencias disponibles.
          </Text>
        )}
      </Stack>
    </Modal>
  );
};

export default ModalUnitEvidences;